/*
 * Generic landing page sections (lp-* sections): analytics to
 * window.dataLayer. Delegated, so theme editor reloads need no re-setup.
 *
 * - lp_research_click: any link to #research.
 * - lp_reference_click (lp_ref = the reference number): a journal link in
 *   lp-references.
 * - lp_video_play: once per page view, the first time the visitor starts the
 *   partner clip (play button, or tapping the clip) or turns its sound on.
 *   Autoplay (optional) never counts: it would fire for everyone who
 *   scrolls past.
 *
 * The clip's play/pause and sound toggle come from assets/listicle.js
 * ([data-ls-video], [data-ls-sound], [data-ls-pause]).
 */
(() => {
  if (window.lpSections) return;
  window.lpSections = { version: 1 };

  let clipPlayed = false;

  function track(event, data = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const control = target.closest('[data-lps-clip] [data-ls-sound], [data-lps-clip] [data-ls-pause]');
    if (control) {
      if (clipPlayed) return;
      const video = control.closest('[data-lps-clip]').querySelector('video');
      // listicle.js acts in its own click handler; read the result after.
      setTimeout(() => {
        if (clipPlayed || !video || video.paused) return;
        if (control.hasAttribute('data-ls-sound') && control.getAttribute('aria-pressed') !== 'true') return;
        clipPlayed = true;
        track('lp_video_play');
      });
      return;
    }

    trackLink(target);
  });

  // Middle-click opens a link in a new tab without a click event.
  document.addEventListener('auxclick', (event) => {
    if (event.button === 1 && event.target instanceof Element) trackLink(event.target);
  });

  function trackLink(target) {
    const link = target.closest('a');
    if (!link) return;
    if (link.dataset.lpsRef) track('lp_reference_click', { lp_ref: Number(link.dataset.lpsRef) });
    const hash = (link.getAttribute('href') || '').split('#')[1];
    if (hash === 'research') track('lp_research_click');
  }
})();
